<script>
	export let data;

	import Navbar from '@components/Navbar/index.svelte';
	import Sidebar from '@components/Sidebar/index.svelte';
	import Titlebar from '@components/Titlebar/index.svelte';
	import Login from '@components/Login/index.svelte';
	import NotificationMessage from '@components/NotificationMessage/index.svelte';
	import { apiErrorHandler } from '$lib/utils/apiErrorHandler';
	import { page } from '$app/stores';
	import {
		TERM,
		CLASSROOMS,
		STUDENTS,
		TERM_DETAILS,
		ADD_STUDENT,
		USER_DETAILS,
		UNIVERSAL_SUCCESS_MESSAGE,
		TOAST_N,
		CURRENT_URL,
		SEARCH_MODE,
		LOGIN_TYPE
	} from '$lib/stores/stores';
	import { GET_STUDENTS } from '$lib/dataproviders/getStudents';
	import { toTitleCase, info, arrayIsNotEqual, checkUserAgentasMobile } from '$lib/utils/helpers';
	import { onMount } from 'svelte';
	import { toastNotify } from '@components/toast';
	import { GET_TERM } from '$lib/dataproviders/getTerms';
	import { PARENT_INFO } from '$lib/stores/parent';
	import { initLogRocket, setupErrorTracking } from '$lib/utils/logrocket';
	import * as Sentry from '@sentry/sveltekit';
	import Error from './+error.svelte';

	// title desc array
	let titleDesc = { title: '', desc: '' };

	onMount(async () => {
		// initialize logrocket
		if (import.meta.env.VITE_LOGROCKET_ID) {
			await initLogRocket(import.meta.env.VITE_LOGROCKET_ID, $USER_DETAILS);

			// setup error tracking
			await setupErrorTracking();

			/* logRocket.getSessionURL((sessionURL) => {
				Sentry.configureScope((scope) => {
					scope.setExtra('sessionURL', sessionURL);
				});
			}); */
		}

		if (!$USER_DETAILS) {
			if ($page.url.pathname.includes('parent')) {
				LOGIN_TYPE.set('parent');
			} else {
				LOGIN_TYPE.set('staff');
			}
			// if (data.showError) {
			// 	UNIVERSAL_ERROR_MESSAGE.set('Login Required!');
			// }
		}
	});
	let tempTerm = $TERM;
	let tempClassrooms = $CLASSROOMS || [];

	const parent = data?.user_type?.toLowerCase() === 'parent';

	const getStudentsAfterAdd = async () => {
		await getStudents($TERM, $CLASSROOMS);
		ADD_STUDENT.set(false);
	};

	const getParentStudents = async () => {
		$PARENT_INFO?.students && $PARENT_INFO?.students.length > 0
			? await STUDENTS.set($USER_DETAILS?.students)
			: await STUDENTS.set([]);
	};

	let msg = '';
	const getStudents = async (term, classrooms) => {
		if (!term || classrooms.length === 0 || data.isLoggedIn === false) {
			return;
		}
		if ($page.url.pathname.includes('/reports/verification')) {
			return;
		}
		await STUDENTS.set([]);
		const callback = async (res, message) => {
			if (res) {
				const unique = res.filter(
					(value, index, self) => index === self.findIndex((t) => t.studentid === value.studentid)
				);
				await STUDENTS.set(unique);
				// clear search mode
				SEARCH_MODE.set(false);
				// prevents multiple messages
				// only displays on term or classroom change
				// only displays on students page
				if (
					$page.url.pathname.includes('/students') &&
					(msg !== message || tempTerm !== $TERM || tempClassrooms !== $CLASSROOMS)
				) {
					toastNotify(toTitleCase(message), 'success');
					msg = message;
				}
			}
		};
		const onError = async (error) => {
			await STUDENTS.set([]);
		};
		GET_STUDENTS(term, classrooms, $USER_DETAILS?.school[0]?.schoolid, callback, onError);
	};

	const getTerm = async (term_id) => {
		if (!term_id || data.isLoggedIn === false) {
			return;
		}
		const callback = async (res, message) => {
			if (res) {
				await TERM_DETAILS.set(res[0]);
			}
		};
		const onError = (error) => {
			apiErrorHandler(error);
		};
		GET_TERM(term_id, callback, onError);
	};

	// store current url for re-login purposes
	$: {
		if ($page.url.pathname) {
			CURRENT_URL.set($page.url.pathname);
		}
	}

	$: if (tempTerm !== $TERM && parent === false) {
		getStudents($TERM, $CLASSROOMS);
		getTerm($TERM);
		tempTerm = $TERM;
	}
	$: if (arrayIsNotEqual(tempClassrooms, $CLASSROOMS) && parent === false) {
		getStudents($TERM, $CLASSROOMS);
		tempClassrooms = $CLASSROOMS;
	}
	$: $USER_DETAILS && parent === false && $ADD_STUDENT && getStudentsAfterAdd($ADD_STUDENT);

	$: $USER_DETAILS && parent === true && getParentStudents();

	$: {
		if ($UNIVERSAL_SUCCESS_MESSAGE !== '') {
			toastNotify($UNIVERSAL_SUCCESS_MESSAGE, 'success');
			UNIVERSAL_SUCCESS_MESSAGE.set('');
		}
	}
</script>

{#if $TOAST_N}
	<NotificationMessage
		showNotifier={true}
		kind={$TOAST_N.kind}
		title={$TOAST_N.title}
		message={$TOAST_N.message}
	/>
{/if}

{#if $page.error}
	<Error />
{:else if data.isLoggedIn}
	{#if $page.url.pathname.includes('/reports/verification') || (checkUserAgentasMobile() && !parent) || $page.url.pathname.includes('/visualize-report') || $page.url.pathname.includes('/report-comments')}
		<slot />
	{:else}
		<!-- handles by desktop layout -->
		<slot />
	{/if}
{:else if $page.url.pathname.includes('/parents') && !data.isLoggedIn}
	<Login returnUrl={data.route} currentUrl={data.current_url} userType="parent" />
{:else}
	<Login returnUrl={data.route} currentUrl={data.current_url} userType="staff" />
{/if}
